import React, { useState, useEffect } from "react";
import { Box, Tabs, Tab, Typography, Paper } from "@mui/material";
import Login from "./Login";
import Image from 'react-bootstrap/Image';
// import '../../src/style/css/_login.css'

export default function LoginPage() {
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_uuid");
    localStorage.removeItem("user_name");
    localStorage.removeItem("token");
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <div className="LoginManagement">
      <div
        className="banner-1 login-page"
        style={{
          backgroundImage: `url(/assets/images/bg_login@2x.png)`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          color: '#ffffff',
          padding: '0px',
        }}
      >
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "transparent",
            p: 2,
          }}
        >
          <Image alt="Cloudgoda" src="/assets/images/logo_deep_login_pg@2x.png" rounded style={{ width: '150px', height: 'auto' }}/>
          <Paper elevation={3} sx={{ width: "100%", maxWidth: 400, p: 3 }}>
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              variant="fullWidth"
              // sx={{ mb: 2 }}
              sx={{
                mb: 2,
                '& .MuiTabs-indicator': {
                  backgroundColor: '#7FBE25',
                  height: '3px',
                },
              }}
            >
              <Tab
                className={`text-tab ${tabIndex === 0 && 'active'} `}
                label="登入"
                style={{
                    color: tabIndex === 0 ? '#7FBE25' : '#757474',
                    fontSize: '16px',
                    fontWeight: 'bold',
                }}
              />
            </Tabs>
            <Box>
              {tabIndex === 0 && <Login />}
            </Box>
          </Paper>
        </Box>
      </div>
    </div>
  );
}
